import i18next from 'i18next';

// Import types
import { Operators, Systems } from 'types/api/systems';

export const SystemOperator = {
	[Systems.Retail]: Operators.Retail,
	[Systems.Vectra]: Operators.Vectra,
	[Systems.Multimedia]: Operators.Multimedia,
	[Systems.Sgt]: Operators.Sgt,
	[Systems.Elsat]: Operators.Elsat,
	[Systems.Satfilm]: Operators.Satfilm
};

export const CURRENT_OPERATOR = process.env.REACT_APP_OPERATOR as Operators;

export const CURRENT_SYSTEM = process.env.REACT_APP_SYSTEM as Systems;

export const isRetail = CURRENT_OPERATOR === Operators.Retail;

export const ALL_OPERATORS = Object.values(Operators);

export const PACKETS_OPERATORS = [Operators.Vectra];

export const RECORDINGS_OPERATORS = [Operators.Vectra, Operators.Sgt, Operators.Multimedia, Operators.Elsat, Operators.Satfilm];

export const REGULATION_OPERATORS = [Operators.Vectra, Operators.Sgt, Operators.Multimedia, Operators.Elsat, Operators.Satfilm];

export const DOCUMENT_OPERATORS = [Operators.Retail];

export const CONFIGURATOR_OPERATORS = [Operators.Retail];

export const filterOperatorLinks = ({ operators }: { operators: Operators[] }) => operators.includes(CURRENT_OPERATOR);

export const getOperatorContact = () => {
	switch (CURRENT_OPERATOR) {
		case Operators.Retail:
			return '/kontakt';
		default:
			return '/strona/kontakt';
	}
};

export const getCustomerAreaData = () => {
	const caText = i18next.t(`operators_customer_area_text_${CURRENT_OPERATOR}`);
	const caUrl = i18next.t(`operators_customer_area_url_${CURRENT_OPERATOR}`);
	const caLogoAlt = i18next.t(`operators_customer_area_alt_${CURRENT_OPERATOR}`);

	const caLogoUrl = i18next.t(`operators_customer_area_logo_url`, {
		operator: CURRENT_OPERATOR
	});

	return { caText, caUrl, caLogoAlt, caLogoUrl };
};

export const isRecordingsOperator = RECORDINGS_OPERATORS.includes(CURRENT_OPERATOR);
